module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicWide-Bold-7db877bc5cfe98abe187609adcf04d05.ttf";